import { render, staticRenderFns } from "./WorkColumn.vue?vue&type=template&id=3778eca7"
import script from "./WorkColumn.vue?vue&type=script&lang=js"
export * from "./WorkColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports